<as-split class="listing" direction="horizontal" [gutterSize]="18">
    <as-split-area [size]="20">

      <div class="dataset-listing-tree">
        <restoreid-group-tree-node *ngFor="let node of groupTreeList" [node]="node"></restoreid-group-tree-node>
      </div>
    </as-split-area>

    <as-split-area [size]="80">
      <ng-container *ngIf="selectedGroup">
        <restoreid-group-user-list [groupId]="selectedGroup.id" *ngIf="selectedGroup?.id"></restoreid-group-user-list>
      </ng-container>
    </as-split-area>
  </as-split>